module.exports = __webpack_public_path__ + "img/premium-icon-inactive.caff0d1d.svg";